import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index.tsx";
import Login from "./pages/Login.tsx";
import GetStarted from "./pages/GetStarted.tsx";
import Dashboard from "./pages/Dashboard.tsx";
import ProviderRegister from "./pages/ProviderRegister.tsx";
import AdminDashboard from "./pages/AdminDashboard.tsx";
import ProviderDashboard from "./pages/ProviderDashboard.tsx";
import ProviderProfile from "./pages/ProviderProfile.tsx";
import BookingPage from "./pages/BookingPage.tsx";
import PeptideEducation from "./pages/PeptideEducation.tsx";
import PaymentSuccess from "./pages/PaymentSuccess.tsx";
import SalesDashboard from "./pages/SalesDashboard.tsx";
import PharmacyDashboard from "./pages/PharmacyDashboard.tsx";
import CustomizePlan from "./pages/CustomizePlan.tsx";
import Settings from "./pages/Settings.tsx";
import Unsubscribe from "./pages/Unsubscribe.tsx";
import About from "./pages/About.tsx";
import Careers from "./pages/Careers.tsx";
import Contact from "./pages/Contact.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";
import TermsOfService from "./pages/TermsOfService.tsx";
import HIPAANotice from "./pages/HIPAANotice.tsx";
import ForgotPassword from "./pages/ForgotPassword.tsx";
import ResetPassword from "./pages/ResetPassword.tsx";
import MedicalDisclaimer from "./pages/MedicalDisclaimer.tsx";
import ReferralRedirect from "./pages/ReferralRedirect.tsx";
import NotFound from "./pages/NotFound.tsx";
import SalesRegister from "./pages/SalesRegister.tsx";
import PharmacyRegister from "./pages/PharmacyRegister.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/book" element={<ProtectedRoute><BookingPage /></ProtectedRoute>} />
            <Route path="/peptides" element={<PeptideEducation />} />
            <Route path="/customize" element={<CustomizePlan />} />
            <Route path="/provider/register" element={<ProviderRegister />} />
            <Route path="/provider" element={<ProtectedRoute><ProviderDashboard /></ProtectedRoute>} />
            <Route path="/provider/profile" element={<ProtectedRoute><ProviderProfile /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/sales" element={<ProtectedRoute><SalesDashboard /></ProtectedRoute>} />
            <Route path="/pharmacy" element={<ProtectedRoute><PharmacyDashboard /></ProtectedRoute>} />
            <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/hipaa" element={<HIPAANotice />} />
            <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
            <Route path="/r/:code" element={<ReferralRedirect />} />
            <Route path="/join/provider" element={<ProviderRegister />} />
            <Route path="/join/sales" element={<SalesRegister />} />
            <Route path="/join/pharmacy" element={<PharmacyRegister />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
